var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"quiz__back",attrs:{"type":"button"},on:{"click":_vm.backToStep}},[_c('span',{staticClass:"btn-back"}),_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }